import { render } from "./arrow.vue?vue&type=template&id=595ad9ae&ts=true"
import script from "./arrow.ts?vue&type=script&lang=ts"
export * from "./arrow.ts?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__